<template>
  <list-page-layout class="lease-list-page" :pageSize="pageSize" :currentPage="pageIndex" :total="total"  @current-change="handleChange" @size-change="handleSizeChange">
    <span slot="title">委托销售收入报表</span>
    <el-form slot="search-bar" :inline="true">
      <el-form-item label="物料名称">
        <el-input class="form-input" v-model="Search.Product" placeholder="请输入物料名称/物料编码" @keyup.enter.native="handleSearch"></el-input>
      </el-form-item>
      <el-form-item label="品牌">
        <el-select v-model="Search.Brand" class="form-item" placeholder="请选择或输入品牌" allow-create clearable filterable>
            <el-option
            v-for="item in Brand"
            :key="item.Id"
            :label="item.Name"
            :value="item.Name">
            </el-option>
          </el-select>
      </el-form-item>
      <el-form-item label="机型">
        <el-select v-model="Search.Machine" class="form-item" placeholder="请选择或输入机型" allow-create clearable filterable>
            <el-option
            v-for="item in Machine"
            :key="item.Id"
            :label="item.Name"
            :value="item.Name">
            </el-option>
          </el-select>
      </el-form-item>
      <el-form-item label="模块">
        <el-select v-model="Search.Module" class="form-item" placeholder="请选择或输入模块" allow-create clearable filterable>
            <el-option
            v-for="item in Module"
            :key="item.Id"
            :label="item.Name"
            :value="item.Name">
            </el-option>
          </el-select>
      </el-form-item>
      <el-form-item label="批次号">
        <el-input class="form-input" v-model="Search.LotCode" placeholder="请输入批次号" @keyup.enter.native="handleSearch"></el-input>
      </el-form-item>
      <el-form-item label="区域">
        <el-select v-model="Search.Region" class="form-item" filterable placeholder="请选择或输入区域"clearable>
            <el-option
            v-for="item in Region"
            :key="item.Id"
            :label="item.Name"
            :value="item.Name">
            </el-option>
          </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" :loading="IsLoading" @click="handleSearch" style="width: 120px">查询</el-button>
      </el-form-item>
    </el-form>
    <div class="tabs" slot="tabs">
      <el-tabs class="tab" :value="currentTab" @tab-click="handleTabClick">
        <el-tab-pane label="待收款" name="false"></el-tab-pane>
        <el-tab-pane label="已收款" name="true"></el-tab-pane>
      </el-tabs>
      <div class="payment_box">
        已收款：<span class="green">￥{{receiptFee}}</span>
      </div>
    </div>
      <complex-grid v-loading="IsLoading" element-loading-text="加载中" :config="tableConfig" :data="List" slot="main-content">
        <template slot="sub-header" scope="props">
          <el-col :span="20">
            <span>出售时间：{{props.row.CreateOn | date('YYYY-MM-DD HH:mm:ss')}}</span>
            <span style="margin-left: 20px">流水号：{{props.row.Code}}</span>
            <span style="margin-left: 20px">批次号：{{props.row.BatchCode}}</span>
            <span style="margin-left: 20px">区域：{{props.row.Area}}</span>
          </el-col>
          <el-col :span="2" :offset="2">
            状态：<span style="color:red">{{props.row.State}}</span>
          </el-col>
        </template>
        <template slot="ProductName" scope="props">
          <p style="margin: 4px 0">{{props.row.ItemName}}</p>
          <p style="margin: 4px 0">物料编码：{{props.row.ItemCode}}</p>
        </template>
        <template slot="CustomerProductName" scope="props">
          <p style="margin: 4px 0">{{props.row.CustomerItemName | NullShow}}</p>
          <p style="margin: 4px 0">物料编码：{{props.row.CustomerItemCode | NullShow}}</p>
        </template>
        <template slot="ProductConditionName" scope="props">
          <el-tag :type="props.row.ItemQualityName | ConditionColor">{{props.row.ItemQualityName}}</el-tag>
        </template>
        <template slot="Brand" scope="props">
          <p type="primary">{{props.row.Brand}}</p>
        </template>
        <template slot="Machine" scope="props">
          <p type="primary">{{props.row.Machine}}</p>
        </template>
        <template slot="Module" scope="props">
          <p type="primary">{{props.row.Module}}</p>
        </template>
        <template slot="TotalAmount" scope="props">
          <p type="primary">{{props.row.TotalAmount | amount}}</p>
        </template>
        <template slot="Quantity" scope="props">
          <p type="primary">{{props.row.Quantity}}</p>
        </template>
        <template slot="action-bar" scope="props">
          <!-- <router-link :to="{name: 'EntrustDetail', params: {id:props.row.ID}}">
            <el-button type="text">查看</el-button>
          </router-link> -->
        </template>
      </complex-grid>
  </list-page-layout>
</template>

<script>
import Countdown from '@/components/common/Countdown'
import ListPageLayout from '@/components/common/ListPageLayout'
import ComplexGrid from '@/components/common/ComplexGrid'
import o from '@/odata'
export default {
  data() {
    return {
      Search: {
        Product: null,
        Brand: null,
        Machine: null,
        Module: null,
        Region: null,
        LotCode: null,
      },
      Brand: null,
      Machine: null,
      Module: null,
      Region: null,
      currentTab: '待收款',
      pageSize: 10,
      pageIndex: 1,
      tableConfig: {
        dataPrefix: 'LotList',
        column: [
          {
            label: '物品名称/编码',
            width: '260px',
            slot: 'ProductName',
          },
          {
            label: '客户物料名称/编码',
            slot: 'CustomerProductName',
            width: '260px',
          },
          {
            label: '品项',
            slot: 'ProductConditionName',
            width: '140px',
          },
          {
            label: '品牌',
            slot: 'Brand',
          },
          {
            label: '机型',
            slot: 'Machine',
            width: '120px',
          },
          {
            label: '模块',
            slot: 'Module',
          },
          {
            label: '数量',
            slot: 'Quantity',
          },
          {
            label: '出售收入',
            slot: 'TotalAmount',
            width: '100px',
          },
          {
            label: '操作',
            collapse: true,
            key: 'action-bar',
            class: 'text-center',
            width: '100px',
          },
        ],
      },
      IsLoading: false,
      tableData: [],
      List: [],
      Lists: [],
      receiptFee: null,
      total: 0,
      listURL: process.env.API_HOST + '/finance/PurchaseOrder/Income/Report',
    }
  },
  methods: {
    initTotal() {
      o(`Partner/Services.GetCurrentCustomer()`).get().then(({ data }) => {
        let CustomerCode = data.CustomerCode
        let URL = process.env.API_HOST + '/finance/PurchaseOrder/Income/Total?code=' + CustomerCode
        this.$http.get(URL).then((response) => {
          this.receiptFee = response.data
        }).catch((response) => {})
      }).fail((error) => {
        this.$alert(error.message)
      })
    },
    handleSearch() {
      this.IsLoading = true
      let filters = ''
      if (this.Search.Product) {
        filters += '&input.material=' + this.Search.Product
      }
      if (this.currentTab) {
        filters += '&input.IsReceived=' + this.currentTab
      }
      if (this.Search.Machine) {
        filters += '&input.machine=' + this.Search.Machine
      }
      if (this.Search.LotCode) {
        filters += '&input.batchCode=' + this.Search.LotCode
      }
      if (this.Search.Brand) {
        filters += '&input.brand=' + this.Search.Brand
      }
      if (this.Search.Module) {
        filters += '&input.module=' + this.Search.Module
      }
      if (this.Search.Area) {
        filters += '&input.area=' + this.Search.Area
      }
      // filters.join('&')
      const user = JSON.parse(window.localStorage.getItem('CURRENT_USER'))
      let URL = this.listURL + '?input.customer=' + user.userName + '&input.pageSize=' + this.pageSize + '&input.pageIndex=' + this.pageIndex + filters
      // console.log(URL)
      this.$http.get(URL).then((response) => {
        this.IsLoading = false
        const data = response.data
        data.List.forEach(Lists => {
          const LotList = []
          const Lot = {
            ItemCode: Lists.ItemCode,
            ItemName: Lists.ItemName,
            ItemQuality: Lists.ItemQuality,
            ItemQualityName: Lists.ItemQualityName,
            Brand: Lists.Brand,
            Machine: Lists.Machine,
            Module: Lists.Module,
            Quantity: Lists.Quantity,
            TotalAmount: Lists.TotalAmount,
          }
          LotList.push(Lot)
          Lists.LotList = LotList
        })
        this.tableData = data
        this.List = this.tableData.List
        this.PageSize = this.tableData.PageSize
        this.total = this.tableData.Total
      }).catch((response) => {
        this.IsLoading = false
        console.log(response)
      })
    },
    handleTabClick({name}) {
      this.currentTab = name
      this.handleSearch()
    },
    handleChange(params) {
      this.pageIndex = params
      this.handleSearch()
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize
      this.handleSearch()
    },
    initBrand() {
      o('ProductBrand').get()
      .then((response) => {
        this.Brand = response.data
      }).catch((err) => {
        console.log(err)
      })
    },
    initModel() {
      o('ProductModel').get()
      .then((response) => {
        this.Machine = response.data
      }).catch((err) => {
        console.log(err)
      })
    },
    initModule() {
      o('ProductModule').get()
      .then((response) => {
        this.Module = response.data
      }).catch((err) => {
        console.log(err)
      })
    },
    initRegion() {
      o('Region').get()
      .then((response) => {
        this.Region = response.data
      }).catch((err) => {
        console.log(err)
      })
    },
  },
  components: {
    ListPageLayout,
    ComplexGrid,
    Countdown,
  },
  created() {
    this.handleSearch()
    this.initBrand()
    this.initModel()
    this.initModule()
    this.initRegion()
    this.initTotal()
  },
}
</script>

<style lang="less" scoped>
.form-input {
  width: 260px;
}
.green{
  color: green;
}
</style>

<style lang="less">
.lease-list-page .el-tabs__active-bar{
  display: none;
}
.main-content{
  .tab{
    .el-tabs__active-bar{
      background-color: rgba(0,0,0,0);
    }
  }
}
.payment_box{
  position: absolute;
  top:15px;
  right: 15px;
}
</style>




// WEBPACK FOOTER //
// EntrustedSale_statement.vue?c6e32c9a